'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import CanvasToolbarButton from 'rich-text-lib/components/toolbar/ToolbarButton';
import withSelectedState from '../hoc/withSelectedState';
import EmojiPopoverManager from '../components/EmojiPopoverManager';
import { CANVAS_EMOJI } from '../constants/toolbar';
import { HS_EMOJI } from '../constants/plugins';
import { INSERT_EMOJI, OPEN_EMOJI_POPOVER } from '../constants/usageTracking';
import { trackInteraction } from '../utils/usageTracking';
import { i18nWithNameSpace } from '../utils/i18n';
import { getPickerComponent } from '../utils/settings';
import { jsx as _jsx } from "react/jsx-runtime";
const CanvasToolbarButtonWithSelectedState = withSelectedState(CanvasToolbarButton);
const openChangeKey = 'hsEmojiOpenChange';
const i18nKey = i18nWithNameSpace('TinymcePlugins.hsemoji');
let emojiInsertCount = 0;
const getEmojiInsertCount = () => {
  emojiInsertCount++;
  return emojiInsertCount;
};
const resetEmojiInsertCount = () => {
  emojiInsertCount = 0;
};
export function addControls(editor, getStoreHandlers = () => {}) {
  const handleClick = () => editor.fire('OpenEmojiPopover');
  const handleMouseEnter = () => editor.fire('PreloadEmojiPicker');
  const handleInsert = emoji => {
    editor.insertContent(emoji.native);
    trackInteraction(editor, 'tinymceInsertEmoji', INSERT_EMOJI, {
      insertCount: getEmojiInsertCount(),
      version: 'v1'
    });
  };
  const handleOpenChange = isOpen => {
    if (isOpen) {
      resetEmojiInsertCount();
      trackInteraction(editor, 'tinymceEmoji', OPEN_EMOJI_POPOVER, {
        version: 'v1'
      });
    }
    editor.fire(openChangeKey, {
      selected: isOpen
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_EMOJI, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(CanvasToolbarButtonWithSelectedState, Object.assign({
        "data-test-id": "insert-emoji-button",
        iconName: "emoji",
        tooltip: i18nKey('tooltip'),
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        editor: editor,
        eventKey: openChangeKey
      }, rest));
    }
  });
  tinymce.canvas.addMenuItem(editor, CANVAS_EMOJI, {
    text: i18nKey('menuItem'),
    onClick: handleClick
  });
  const EmojiPicker = getPickerComponent(editor, 'EmojiPicker', '`EmojiPicker` picker component is required for the emoji plugin');
  tinymce.canvas.addPopover(editor, HS_EMOJI, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(EmojiPopoverManager, Object.assign({
        editor: editor,
        onInsert: handleInsert,
        onOpenChange: handleOpenChange,
        EmojiPicker: EmojiPicker,
        storeHandlers: getStoreHandlers(editor)
      }, renderProps));
    }
  });
}